import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { AuthService } from "@kernel/tools/services/auth.service";

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  // if token is not empty then add it to the request headers
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
